import React from 'react'
import styles from './styles.css'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import useMessage from 'App/hooks/useMessage'
import useState from 'App/hooks/useState'

export default function FreeDriver(props) {
  const {order, onSuccess} = props
  const [loading, setLoading] = useState()

  const mutate = useMutate()
  const showMessage = useMessage()

  const reassignOrder = async () => {
    setLoading(true)
    try {
      await mutate({
        mutation: gql`
          mutation reassignOrder($orderId: ID) {
            reassignOrder(orderId: $orderId) {
              _id
            }
          }
        `,
        variables: {orderId: order._id}
      })
      showMessage('Se liberó el repartidor')
    } catch (error) {
      showMessage(error)
    }
    onSuccess()
    setLoading(false)
  }

  const nearPointText =
    order.pointsNearAt && order.pointsNearAt.length > 0
      ? `(Está cerca del punto ${order.pointsNearAt.length})`
      : '(Está lejos del punto 1)'

  return (
    <div className={styles.container}>
      {loading ? (
        <div>Liberar driver {nearPointText}</div>
      ) : (
        <a onClick={reassignOrder}>Liberar driver {nearPointText}</a>
      )}
    </div>
  )
}
